@if (initialized) {
  <div>
    <div class="row">
      <div></div>
      <div class="icons">
        <button mat-flat-button color="accent" (click)="openInviteCreate()"
        [disabled]="!('create' | able: newInvite)">Invite</button>
      </div>
    </div>
    @if (!invitations.length) {
      <div class="mat-body-strong">No invitations to show</div>
    }
    @if (invitations.length) {
      <div class="cards-container">
        @for (invite of invitations; track invite) {
          <div (click)="openInviteCreate(invite)" class="link stroked-card">
            <div class="line">
              <div class="mat-body-strong capitalize">{{invite.first_name}} {{invite.last_name}}</div>
              <div class="mat-caption">
                @switch (invite.status) {
                  @case ('invited') {
                    invited on {{invite.created_at | dateFormat: 'long'}}
                  }
                  @case ('logged_in') {
                    logged in {{invite.accepted_at | dateFormat: 'long'}}
                  }
                  @case ('accepted') {
                    accepted on {{invite.accepted_at | dateFormat: 'long'}}
                  }
                  @case ('added') {
                    added {{invite.accepted_at | dateFormat: 'ago'}} ago
                  }
                }
              </div>
            </div>
            <div class="line">
              <div class="line">
                <mat-icon color="primary">email</mat-icon>{{invite.email}}
              </div>
              <div class="line">
                <mat-icon color="primary">phone</mat-icon>{{invite.phone}}
              </div>
            </div>
            <div class="mat-caption">
              Invited to
              @if (invite.site?.id) {
                Site {{invite.site?.name}}
              }
              @if (!invite.site?.id && invite.project?.id) {
                Project {{invite.project?.name}}
              }
              @if (invite.inviter?.id) {
                by {{invite.inviter?.name}}
              }
            </div>
          </div>
        }
      </div>
    }
    @if (initialized && pagination.length && invitations.length) {
      <mat-paginator (page)="pageChanged($event)"
        [length]="pagination.length" [pageIndex]="pagination.pageIndex" [pageSize]="pagination.pageSize">
      </mat-paginator>
    }
  </div>
}
